import React from 'react';

const ModerationContext = React.createContext(null);

export default ModerationContext;
